import { Img, Text, Heading } from "../index.js";
import { Link } from "react-router-dom";
import { company, footerLinks, socialLinks } from "../../../constants/index.js";
import { MdEmail, MdWhatsapp } from "react-icons/md";

function Footer() {
  const { email, whatsapp, address } = company;
  return (
    <footer className="mt-[71px] self-stretch">
      {/* footer section */}
      <div className="flex justify-center border-t border-solid border-gray-200 py-5">
        <div className="flex w-full items-start  justify-between gap-3 md:w-full sm:flex-col">
          <div className="flex w-[29%] flex-col gap-1 sm:w-full">
            <Link to="/">
              <Img
                src="/images/1.png"
                alt="footer logo"
                className="size-10 w-[120px] object-contain"
              />
            </Link>
            <Text
              as="p"
              className="flex items-center gap-1 hover:text-gray-900 text-wrap"
            >
              Address: {address}
            </Text>
          </div>
          <div className="flex md:flex-col gap-5 md:gap-3">
            {footerLinks.map((item) => (
              <div className="flex flex-col gap-2">
                <Heading as="h6">{item.title}</Heading>
                <ul className="flex flex-col gap-1">
                  {item.links.map((link) => (
                    <li>
                      <Link to={link.url}>
                        <Text as="p" className="hover:text-gray-900">
                          {link.name}
                        </Text>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}

            <div className="flex flex-col gap-2">
              <Heading as="h6">Contact Us</Heading>
              <ul className="flex flex-col gap-1">
                <li>
                  <Link to={`mailto:${email}`}>
                    <Text
                      as="p"
                      className="flex items-center gap-1 hover:text-gray-900"
                    >
                      <MdEmail className="size-5" /> {email}
                    </Text>
                  </Link>
                </li>

                {/* <li>
                  <Link to={`https://api.whatsapp.com/send/?phone=${whatsapp}`}>
                    <Text
                      as="p"
                      className="flex items-center gap-1 hover:text-gray-900"
                    >
                      <MdWhatsapp className="size-5" /> {whatsapp}
                    </Text>
                  </Link>
                </li> */}
              </ul>
            </div>
          </div>
          {/* <div className="flex flex-col gap-2">
              <Heading as="h6">Social Links</Heading>
              <ul className="flex flex-col gap-[11px]">
                {socialLinks.map((link) => (
                  <li>
                    <Link to="#" target="_blank">
                      <div className="flex items-center gap-2 self-start">
                        <Img
                          src={link.icon}
                          alt={link.alt}
                          className="h-[20px] w-[20px]"
                        />
                        <Text as="p">{link.name}</Text>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div> */}
        </div>
      </div>
      <div className="flex justify-center border-t border-solid border-gray-200_01 py-5 sm:py-2 ">
        <div className="container-xs flex items-center justify-between gap-2  sm:flex-col">
          <Text as="p" size="s">
            The Zaik &copy; 2025
          </Text>
          <div className="flex items-center  justify-center gap-1 sm:w-full">
            <div className="flex items-center gap-2 flex-wrap">
              <p className="text-sm font-medium">Delivery Partner:</p>
              <Img
                src="/images/india-post-logo.png"
                alt="India Post"
                className="size-10 w-12 aspect-square"
              />
            </div>
            <Img
              src="/images/HDB.png"
              alt="HDFC Bank Logo"
              className="size-6"
            />
            <Img
              src="/images/paypal-Logo.svg"
              alt="paypal logo"
              className="size-10"
            />

            <Img
              src="/images/stripe.svg"
              alt="vector logo"
              className="size-10 object-contain rounded-lg"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
